import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpAction } from '../symbolLp.action';

type IDependencies = IClientApiDependencySegment;

export const bulkUpdateSymbolLpEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.bulkUpdate.started),
  switchMap((params) => {
    return dependencies.api.bulkUpdateLpSymbols(params).pipe(
      mergeMap(() => [SymbolLpAction.bulkUpdate.done({ params })]),
      catchApiError((error) => [
        SymbolLpAction.bulkUpdate.failed({ params, error }),
        createApiErrorNotification(error),
      ]),
    );
  }),
);
